import { useEffect } from 'react';
import type { createBrowserRouter } from 'react-router';

export const MFE_NAVIGATE_EVENT = 'mfe:navigate';

export interface MfeNavigateEventDetail {
  path: string;
  replace?: boolean;
}

type AppRouter = ReturnType<typeof createBrowserRouter>;

export function useNavigationEvents(router: AppRouter): void {
  useEffect(() => {
    function onNavigate(event: Event) {
      const customEvent = event as CustomEvent<MfeNavigateEventDetail>;
      const { path, replace } = customEvent.detail;

      router.navigate(path, { replace });
    }

    window.addEventListener(MFE_NAVIGATE_EVENT, onNavigate);

    return () => {
      window.removeEventListener(MFE_NAVIGATE_EVENT, onNavigate);
    };
  }, [router]);
}
